import Theme from 'styles/theme';

export const IMAGE_WIDTHS = Object.freeze({
  W_20: 20,
  W_30: 30,
  W_40: 40,
  W_50: 50,
  W_60: 60,
  W_70: 70,
  W_100: 100,
  W_150: 150,
  W_200: 200,
  W_400: 400,
  W_600: 600,
  W_700: 700,
  W_800: 800,
  W_1000: 1000,
  W_1200: 1200,
  W_1300: 1300,
  W_1400: 1400,
  W_1600: 1600,
  W_1800: 1800,
  W_2000: 2000,
  W_2400: 2400,
  W_2600: 2600,
  W_2800: 2800,
  W_3000: 3000,
  W_3200: 3200,
  W_3600: 3600,
});

export const IMAGE_RATIOS = Object.freeze({
  R_1x1: '1:1',
  R_2x3: '2:3',
  R_3x4: '3:4',
  R_3x2: '3:2',
  R_4x3: '4:3',
  R_4x5: '4:5',
  R_5x6: '5:6',
  R_16x9: '16:9',
});

export const IMAGE_BG_COLOR = Theme.get('colors-grey');
